module.exports = __webpack_public_path__ + "static/baby-names-88450380ec8f0c33c7241994cf20da54.png";